import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import { Field, Form } from 'react-final-form';
import TextField from '../_Shares/FormHelpers/TextField';
import TextAreaField from '../_Shares/FormHelpers/TextAreaField';
import validate from './formValidate';
import alertUtils, { SWAL } from '../../utils/alert.util';
import contactApis from '../../apis/contact.api';

const ContactForm = () => {
    const initialData = {
        cu_fullname: '',
        cu_email: '',
        cu_address: '',
        cu_content: '',
    };
    const [intialValues, setInitialValues] = useState(initialData);

    const onSubmitForm = async (s) => {
        setInitialValues(s);
        alertUtils.showLoading('Đang gửi thông tin liên hệ...');
        const { status, data } = await contactApis.send(s);
        if (status !== 200) {
            alertUtils.show(SWAL.TYPE.ERR, data.msg);
            return;
        }
        alertUtils.show(
            SWAL.TYPE.SUCCESS,
            'Bạn đã gửi thông tin liên hệ thành công! Chúng tôi sẽ liên hệ với bạn sớm nhất có thể'
        );
        setInitialValues(initialData);
    };
    return (
        <>
            <Form
                onSubmit={onSubmitForm}
                validate={validate}
                initialValues={intialValues}
                render={({ handleSubmit, invalid, submitting }) => (
                    <div className="content-text">
                        <form>
                            <div class="col-md-5">
                                <div class="form-left-side">
                                    <div class="s-data">
                                        <Field
                                            name="cu_fullname"
                                            component={TextField}
                                            className="form-control"
                                            type="text"
                                            placeholder="Họ tên *"
                                        />
                                    </div>
                                    <div class="s-data">
                                        <Field
                                            name="cu_email"
                                            component={TextField}
                                            className="form-control"
                                            type="text"
                                            placeholder="Email*"
                                        />
                                    </div>
                                    <div class="s-data">
                                        <Field
                                            name="cu_telephone"
                                            component={TextField}
                                            className="form-control"
                                            type="text"
                                            placeholder="Số điện thoại*"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-7">
                                <div class="form-right-side">
                                    <div class="s-data">
                                        <Field
                                            name="cu_content"
                                            component={TextAreaField}
                                            className="form-control"
                                            placeholder="Nội dung *"
                                        />
                                    </div>
                                    <div class="s-data">
                                        <input
                                            type="submit"
                                            value="GỬI ĐI"
                                            onClick={handleSubmit}
                                            disabled={invalid || submitting}
                                        />
                                    </div>
                                </div>
                            </div>
                        </form>
                        {/* <form className="form-horizontal space-50">
                            <div className="form-group col-md-6">
                                <Field
                                    name="cu_fullname"
                                    component={TextField}
                                    className="form-control"
                                    type="text"
                                    placeholder="Họ tên *"
                                />
                            </div>
                            <div className="form-group col-md-6">
                                <Field
                                    name="cu_email"
                                    component={TextField}
                                    className="form-control"
                                    type="text"
                                    placeholder="Email*"
                                />
                            </div>
                            <div className="form-group col-md-12">
                                <Field
                                    name="cu_address"
                                    component={TextField}
                                    className="form-control"
                                    type="text"
                                    placeholder="Địa chỉ"
                                />
                            </div>
                            <div className="form-group">
                                <Field
                                    name="cu_content"
                                    component={TextAreaField}
                                    className="form-control"
                                    placeholder="Nội dung *"
                                />
                            </div>
                            <div className="box align-left">
                                <button
                                    title="add tags"
                                    className="link-v1 rt"
                                    onClick={handleSubmit}
                                    disabled={invalid || submitting}
                                >
                                    Gửi
                                </button>
                            </div>
                        </form> */}
                    </div>
                )}
            ></Form>
        </>
    );
};

export default ContactForm;

document.querySelectorAll('react-contact-form').forEach((domContainer) => {
    const root = createRoot(domContainer);
    root.render(<ContactForm />);
});
